import CustomInput from "../../components/inputs/CustomInputs";
import { CircularProgress } from "@mui/material";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import CustomDialog from "../../components/layouts/common/CustomDialog"



const ResetTokenUi = ({ state, setState, onSubmit, loading }) => {
  return (
    <>
      <CustomDialog
        loading={loading}
        err={state.err}
        onSubmit={onSubmit}
        title={`Reset Password`}
        closeText="Close"
        confirmText={`Reset`}
      >
        {loading ? (
          <CenteredBox>
            <CircularProgress />
          </CenteredBox>
        ) : (
          <>
            <CustomInput
              autoFocus={true}
              disabled={loading}
              value={state.current_pass}
              onChange={(e) =>
                setState({ ...state, err: "", current_pass: e.target.value })
              }
              type="text"
              label={"Old Password*"}
            />

            <CustomInput
              disabled={loading}
              value={state.new_pass}
              onChange={(e) =>
                setState({ ...state, err: "", new_pass: e.target.value })
              }
              type="text"
              label={"New Password*"}
            />
          </>
        )}
      </CustomDialog>
    </>
  );
};
export default ResetTokenUi;
